import { Helmet } from "react-helmet";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FeaturedProducts from "@/components/FeaturedProducts";
import Testimonials from "@/components/Testimonials";
import LatestNews from "@/components/LatestNews";
import Footer from "@/components/Footer";

import SkipToContent from "@/components/SkipToContent";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Natcon Staff Sacco - Your Partner in Prosperity | Financial Services Kenya</title>
        <meta name="description" content="Join Natcon Staff Sacco for savings, loans, and investment opportunities. 10+ years of service, KSh 117.3M+ assets, 280+ members, competitive rates." />
        <link rel="canonical" href="https://natconsacco.or.ke/" />
      </Helmet>
      
      <SkipToContent />
      
      <div className="min-h-screen">
        <Header />
        <main id="main-content" tabIndex={-1} className="focus:outline-none">
          <Hero />
          <FeaturedProducts />
          <Testimonials />
          <LatestNews />
        </main>
        <Footer />
        
        <PWAInstallPrompt />
      </div>
    </>
  );
};

export default Index;
